import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { ITriggerData } from './trigger-data.interface';

/**
 * Représente la classe de base des données d'un trigger.
 */
export class BaseTriggerData implements ITriggerData {
    /**
     * Constructeur.
     * @param type : Type du trigger.
     */
    constructor(public type: WorkflowTriggerTypes) {}

    /**
     * Id du trigger.
     */
    id: number;
}
